module.exports = __webpack_public_path__ + "static/media/web-ar.06c24af2.jpg";